import type { StepProps } from '@/sections/asset/components/tabs/credentials/RecipeWizard/RecipeWizard.types';

import { KVRowsEditor } from './KVRowsEditor';
import { SectionIntro } from './shared';

export function InputsStep({ data, setData }: StepProps) {
  return (
    <div className="space-y-5">
      <SectionIntro
        title="What credentials do you log in with?"
        body={
          <p>
            Referenced in the next step as <code>{`{{name}}`}</code>.
          </p>
        }
      />

      <KVRowsEditor
        rows={data.inputs}
        onChange={inputs => setData(prev => ({ ...prev, inputs }))}
        keyPlaceholder={i => (i === 0 ? 'username' : 'name')}
        addLabel="Add another field"
        minRows={1}
        testIdPrefix="wizard-input"
      />
    </div>
  );
}
